/* eslint-disable react/no-danger */
import React, { useState, useCallback, useRef } from 'react';
import axios from 'axios';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import HelpIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';
import ErrorComponent from '../ErrorComponent';
import './withHelp.scss';

const processDocContent = (doccontent) => {
  const index = doccontent.indexOf('<main>');
  if (index >= 0) {
    const last = doccontent.lastIndexOf('</main>');
    if (last > 0) {
      return doccontent.substring(index, last + 7);
    }
  }
  return doccontent;
};

export default (Component, helpConfig) => {
  if (!helpConfig) {
    return Component;
  }

  const HelpComponent = (props) => {
    const [helpOpened, setHelpOpened] = useState(false);
    const contentRef = useRef();
    const [{ loading, content, error }, setContent] = useState({ loading: false });
    const handleClickHelp = useCallback(() => {
      if (!helpOpened && !content) {
        setContent({ loading: true });
        axios.get(helpConfig.url)
        .then((res) => {
          const pcontent = processDocContent(res.data);
          const innerHTML = {
            __html: pcontent,
          };
          setContent({ content: innerHTML });
          setHelpOpened(true);
        })
        .catch((e) => {
          setContent({ error: e });
          setHelpOpened(true);
        });
      } else {
        setHelpOpened(!helpOpened);
      }
    }, [helpOpened, content, loading]);

    return (
      <React.Fragment>
        <Component
          {...props}
          helpNode={helpConfig.target ? (
            <a
              href={helpConfig.url}
              target={helpConfig.target}
              aria-label="navigate to contextual help"
              rel="noreferrer noopener"
            >
              <IconButton className="grb-form-help-button" disabled={loading}>
                <HelpIcon className="grb-form-help-icon" />
              </IconButton>
            </a>
          ) : (
            <IconButton className="grb-form-help-button" disabled={loading}>
              <HelpIcon className="grb-form-help-icon" onClick={handleClickHelp} />
            </IconButton>
          )}
        />
        {helpOpened && (
          <Dialog
            aria-labelledby={helpConfig.title ? 'contextual-help-dialog-title' : undefined}
            className="grb-contextual-help-dialog"
            onClose={handleClickHelp}
            fullWidth
            maxWidth="md"
            open
          >
            <DialogTitle disableTypography>
              {helpConfig.title ? (
                <Typography variant="h6" className="grb-flex" id="contextual-help-dialog-title">
                  {helpConfig.title}
                </Typography>
              ) : (
                <div className="grb-flex" />
              )}
              <IconButton aria-label="close" onClick={handleClickHelp}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {error ? (
                <ErrorComponent title={`Error loading help for ${helpConfig.title}`} error={error} />
              ) : (
                <div
                  dangerouslySetInnerHTML={content}
                  className="grb-doc-component-content"
                  ref={contentRef}
                />
              )}
            </DialogContent>
          </Dialog>
        )}
      </React.Fragment>
    );
  };

  return HelpComponent;
};
